import Vue from 'vue'
import VueRouter from 'vue-router'
import Top from '../views/Top.vue'
import News from '../views/News.vue'
import NewsDetail from '../views/NewsDetail.vue'
import Contact from '../views/Contact.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Top',
    component: Top,
    meta: {
      title: '株式会社DAYNEEDS（デイニーズ）',
      description: 'Giftissue.comや金券買取EXを運営する株式会社DAYNEEDSの公式ホームページです。'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: {
      title: 'ニュース一覧|株式会社DAYNEEDS（デイニーズ）',
      description: '株式会社DAYNEEDSのニュースやお知らせです。'
    }
  },
  {
    path: '/news/:path',
    name: 'NewsDetail',
    component: NewsDetail,
    meta: {
      title: '|株式会社DAYNEEDS（デイニーズ）'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: 'お問い合わせ|株式会社DAYNEEDS（デイニーズ）',
      description: '株式会社DAYNEEDSへのお問い合わせフォームです。'
    }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: 'ページがありません|株式会社DAYNEEDS（デイニーズ）',
      description: 'ページが見つかりませんでした。',
      robots: 'noindex,nofollow'
    }
  },
  {
    path: '*',
    redirect: {name: 'NotFound'}
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
